function selectActiveInactive(data) {
    const active = [];
    const inactive = [];

    for (let i = 0; i < data.length; i++) {
        const subscription = data[i];

        // Keep treating a pending-unsubscribe id as inactive until the
        // server itself agrees (pendingUnsubscribeIds, see index.js).
        const isPendingUnsubscribe = this.pendingUnsubscribeIds.has(subscription.id);

        if (subscription.isActive && !isPendingUnsubscribe) {
            active.push(subscription);
        } else {
            if (isPendingUnsubscribe && subscription.isActive) {
                // buildSubscriptionMaps() reads sub.isActive directly, so
                // it must be normalized here too, not just re-classified.
                subscription.isActive = false;
            } else if (isPendingUnsubscribe) {
                // Only clear once the server itself agrees — clearing on
                // our own override would let a slower fetch read this
                // id unguarded later.
                this.pendingUnsubscribeIds.delete(subscription.id);
            }
            inactive.push(subscription);
        }
    }

    return { active, inactive };
}

export default selectActiveInactive;
